module.exports = __webpack_public_path__ + "img/banner_5.a66fa64b.png";